// extracted by mini-css-extract-plugin
module.exports = {"top":"GradientOverlay_top__3f1SR","bottom":"GradientOverlay_bottom__2WHaK","both":"GradientOverlay_both__1pjsE"};